// Note that "Changes_When_NFKC_Casefolded" exists, but I'm not using it since casefolding in this file should be independent
// of normalization. I'm not 100% sure this is the correct move, but whatever. grep 7D669B43-CEA7-45E6-AB82-D2B18C20D633
// https://github.com/node-unicode/unicode-15.1.0/blob/main/Binary_Property/Changes_When_Casefolded/regex.js
const changesWhenCasefolded = 
// I'm intentionally ignoring Unicode character class escape /\p{Changes_When_Casefolded}/ https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Regular_expressions/Unicode_character_class_escape
// since "full" case folding may change the number of characters, and I think I need the `v` flag for that https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/unicodeSets
// That flag has mediocre browser support https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/RegExp/unicodeSets
// eslint-disable-next-line no-misleading-character-class
/[A-Z\xB5\xC0-\xD6\xD8-\xDF\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u0149\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u017F\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C5\u01C7\u01C8\u01CA\u01CB\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F2\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0345\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03C2\u03CF-\u03D1\u03D5\u03D6\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F0\u03F1\u03F4\u03F5\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u0587\u10A0-\u10C5\u10C7\u10CD\u13F8-\u13FD\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9A\u1E9B\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1F80-\u1FAF\u1FB2-\u1FB4\u1FB7-\u1FBC\u1FC2-\u1FC4\u1FC7-\u1FCC\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF2-\u1FF4\u1FF7-\u1FFC\u2126\u212A\u212B\u2132\u2160-\u216F\u2183\u24B6-\u24CF\u2C00-\u2C2F\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AE\uA7B0-\uA7B4\uA7B6\uA7B8\uA7BA\uA7BC\uA7BE\uA7C0\uA7C2\uA7C4-\uA7C7\uA7C9\uA7D0\uA7D6\uA7D8\uA7F5\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF21-\uFF3A]|\uD801[\uDC00-\uDC27\uDCB0-\uDCD3\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95]|\uD803[\uDC80-\uDCB2]|\uD806[\uDCA0-\uDCBF]|\uD81B[\uDE40-\uDE5F]|\uD83A[\uDD00-\uDD21]/g;
// https://github.com/node-unicode/unicode-15.1.0/tree/main/Case_Folding
const cft = new Map([
    // C
    ['A', 'a'],
    ['B', 'b'],
    ['C', 'c'],
    ['D', 'd'],
    ['E', 'e'],
    ['F', 'f'],
    ['G', 'g'],
    ['H', 'h'],
    ['I', 'i'],
    ['J', 'j'],
    ['K', 'k'],
    ['L', 'l'],
    ['M', 'm'],
    ['N', 'n'],
    ['O', 'o'],
    ['P', 'p'],
    ['Q', 'q'],
    ['R', 'r'],
    ['S', 's'],
    ['T', 't'],
    ['U', 'u'],
    ['V', 'v'],
    ['W', 'w'],
    ['X', 'x'],
    ['Y', 'y'],
    ['Z', 'z'],
    ['\xB5', '\u03BC'],
    ['\xC0', '\xE0'],
    ['\xC1', '\xE1'],
    ['\xC2', '\xE2'],
    ['\xC3', '\xE3'],
    ['\xC4', '\xE4'],
    ['\xC5', '\xE5'],
    ['\xC6', '\xE6'],
    ['\xC7', '\xE7'],
    ['\xC8', '\xE8'],
    ['\xC9', '\xE9'],
    ['\xCA', '\xEA'],
    ['\xCB', '\xEB'],
    ['\xCC', '\xEC'],
    ['\xCD', '\xED'],
    ['\xCE', '\xEE'],
    ['\xCF', '\xEF'],
    ['\xD0', '\xF0'],
    ['\xD1', '\xF1'],
    ['\xD2', '\xF2'],
    ['\xD3', '\xF3'],
    ['\xD4', '\xF4'],
    ['\xD5', '\xF5'],
    ['\xD6', '\xF6'],
    ['\xD8', '\xF8'],
    ['\xD9', '\xF9'],
    ['\xDA', '\xFA'],
    ['\xDB', '\xFB'],
    ['\xDC', '\xFC'],
    ['\xDD', '\xFD'],
    ['\xDE', '\xFE'],
    ['\u0100', '\u0101'],
    ['\u0102', '\u0103'],
    ['\u0104', '\u0105'],
    ['\u0106', '\u0107'],
    ['\u0108', '\u0109'],
    ['\u010A', '\u010B'],
    ['\u010C', '\u010D'],
    ['\u010E', '\u010F'],
    ['\u0110', '\u0111'],
    ['\u0112', '\u0113'],
    ['\u0114', '\u0115'],
    ['\u0116', '\u0117'],
    ['\u0118', '\u0119'],
    ['\u011A', '\u011B'],
    ['\u011C', '\u011D'],
    ['\u011E', '\u011F'],
    ['\u0120', '\u0121'],
    ['\u0122', '\u0123'],
    ['\u0124', '\u0125'],
    ['\u0126', '\u0127'],
    ['\u0128', '\u0129'],
    ['\u012A', '\u012B'],
    ['\u012C', '\u012D'],
    ['\u012E', '\u012F'],
    ['\u0132', '\u0133'],
    ['\u0134', '\u0135'],
    ['\u0136', '\u0137'],
    ['\u0139', '\u013A'],
    ['\u013B', '\u013C'],
    ['\u013D', '\u013E'],
    ['\u013F', '\u0140'],
    ['\u0141', '\u0142'],
    ['\u0143', '\u0144'],
    ['\u0145', '\u0146'],
    ['\u0147', '\u0148'],
    ['\u014A', '\u014B'],
    ['\u014C', '\u014D'],
    ['\u014E', '\u014F'],
    ['\u0150', '\u0151'],
    ['\u0152', '\u0153'],
    ['\u0154', '\u0155'],
    ['\u0156', '\u0157'],
    ['\u0158', '\u0159'],
    ['\u015A', '\u015B'],
    ['\u015C', '\u015D'],
    ['\u015E', '\u015F'],
    ['\u0160', '\u0161'],
    ['\u0162', '\u0163'],
    ['\u0164', '\u0165'],
    ['\u0166', '\u0167'],
    ['\u0168', '\u0169'],
    ['\u016A', '\u016B'],
    ['\u016C', '\u016D'],
    ['\u016E', '\u016F'],
    ['\u0170', '\u0171'],
    ['\u0172', '\u0173'],
    ['\u0174', '\u0175'],
    ['\u0176', '\u0177'],
    ['\u0178', '\xFF'],
    ['\u0179', '\u017A'],
    ['\u017B', '\u017C'],
    ['\u017D', '\u017E'],
    ['\u017F', 's'],
    ['\u0181', '\u0253'],
    ['\u0182', '\u0183'],
    ['\u0184', '\u0185'],
    ['\u0186', '\u0254'],
    ['\u0187', '\u0188'],
    ['\u0189', '\u0256'],
    ['\u018A', '\u0257'],
    ['\u018B', '\u018C'],
    ['\u018E', '\u01DD'],
    ['\u018F', '\u0259'],
    ['\u0190', '\u025B'],
    ['\u0191', '\u0192'],
    ['\u0193', '\u0260'],
    ['\u0194', '\u0263'],
    ['\u0196', '\u0269'],
    ['\u0197', '\u0268'],
    ['\u0198', '\u0199'],
    ['\u019C', '\u026F'],
    ['\u019D', '\u0272'],
    ['\u019F', '\u0275'],
    ['\u01A0', '\u01A1'],
    ['\u01A2', '\u01A3'],
    ['\u01A4', '\u01A5'],
    ['\u01A6', '\u0280'],
    ['\u01A7', '\u01A8'],
    ['\u01A9', '\u0283'],
    ['\u01AC', '\u01AD'],
    ['\u01AE', '\u0288'],
    ['\u01AF', '\u01B0'],
    ['\u01B1', '\u028A'],
    ['\u01B2', '\u028B'],
    ['\u01B3', '\u01B4'],
    ['\u01B5', '\u01B6'],
    ['\u01B7', '\u0292'],
    ['\u01B8', '\u01B9'],
    ['\u01BC', '\u01BD'],
    ['\u01C4', '\u01C6'],
    ['\u01C5', '\u01C6'],
    ['\u01C7', '\u01C9'],
    ['\u01C8', '\u01C9'],
    ['\u01CA', '\u01CC'],
    ['\u01CB', '\u01CC'],
    ['\u01CD', '\u01CE'],
    ['\u01CF', '\u01D0'],
    ['\u01D1', '\u01D2'],
    ['\u01D3', '\u01D4'],
    ['\u01D5', '\u01D6'],
    ['\u01D7', '\u01D8'],
    ['\u01D9', '\u01DA'],
    ['\u01DB', '\u01DC'],
    ['\u01DE', '\u01DF'],
    ['\u01E0', '\u01E1'],
    ['\u01E2', '\u01E3'],
    ['\u01E4', '\u01E5'],
    ['\u01E6', '\u01E7'],
    ['\u01E8', '\u01E9'],
    ['\u01EA', '\u01EB'],
    ['\u01EC', '\u01ED'],
    ['\u01EE', '\u01EF'],
    ['\u01F1', '\u01F3'],
    ['\u01F2', '\u01F3'],
    ['\u01F4', '\u01F5'],
    ['\u01F6', '\u0195'],
    ['\u01F7', '\u01BF'],
    ['\u01F8', '\u01F9'],
    ['\u01FA', '\u01FB'],
    ['\u01FC', '\u01FD'],
    ['\u01FE', '\u01FF'],
    ['\u0200', '\u0201'],
    ['\u0202', '\u0203'],
    ['\u0204', '\u0205'],
    ['\u0206', '\u0207'],
    ['\u0208', '\u0209'],
    ['\u020A', '\u020B'],
    ['\u020C', '\u020D'],
    ['\u020E', '\u020F'],
    ['\u0210', '\u0211'],
    ['\u0212', '\u0213'],
    ['\u0214', '\u0215'],
    ['\u0216', '\u0217'],
    ['\u0218', '\u0219'],
    ['\u021A', '\u021B'],
    ['\u021C', '\u021D'],
    ['\u021E', '\u021F'],
    ['\u0220', '\u019E'],
    ['\u0222', '\u0223'],
    ['\u0224', '\u0225'],
    ['\u0226', '\u0227'],
    ['\u0228', '\u0229'],
    ['\u022A', '\u022B'],
    ['\u022C', '\u022D'],
    ['\u022E', '\u022F'],
    ['\u0230', '\u0231'],
    ['\u0232', '\u0233'],
    ['\u023A', '\u2C65'],
    ['\u023B', '\u023C'],
    ['\u023D', '\u019A'],
    ['\u023E', '\u2C66'],
    ['\u0241', '\u0242'],
    ['\u0243', '\u0180'],
    ['\u0244', '\u0289'],
    ['\u0245', '\u028C'],
    ['\u0246', '\u0247'],
    ['\u0248', '\u0249'],
    ['\u024A', '\u024B'],
    ['\u024C', '\u024D'],
    ['\u024E', '\u024F'],
    ['\u0345', '\u03B9'],
    ['\u0370', '\u0371'],
    ['\u0372', '\u0373'],
    ['\u0376', '\u0377'],
    ['\u037F', '\u03F3'],
    ['\u0386', '\u03AC'],
    ['\u0388', '\u03AD'],
    ['\u0389', '\u03AE'],
    ['\u038A', '\u03AF'],
    ['\u038C', '\u03CC'],
    ['\u038E', '\u03CD'],
    ['\u038F', '\u03CE'],
    ['\u0391', '\u03B1'],
    ['\u0392', '\u03B2'],
    ['\u0393', '\u03B3'],
    ['\u0394', '\u03B4'],
    ['\u0395', '\u03B5'],
    ['\u0396', '\u03B6'],
    ['\u0397', '\u03B7'],
    ['\u0398', '\u03B8'],
    ['\u0399', '\u03B9'],
    ['\u039A', '\u03BA'],
    ['\u039B', '\u03BB'],
    ['\u039C', '\u03BC'],
    ['\u039D', '\u03BD'],
    ['\u039E', '\u03BE'],
    ['\u039F', '\u03BF'],
    ['\u03A0', '\u03C0'],
    ['\u03A1', '\u03C1'],
    ['\u03A3', '\u03C3'],
    ['\u03A4', '\u03C4'],
    ['\u03A5', '\u03C5'],
    ['\u03A6', '\u03C6'],
    ['\u03A7', '\u03C7'],
    ['\u03A8', '\u03C8'],
    ['\u03A9', '\u03C9'],
    ['\u03AA', '\u03CA'],
    ['\u03AB', '\u03CB'],
    ['\u03C2', '\u03C3'],
    ['\u03CF', '\u03D7'],
    ['\u03D0', '\u03B2'],
    ['\u03D1', '\u03B8'],
    ['\u03D5', '\u03C6'],
    ['\u03D6', '\u03C0'],
    ['\u03D8', '\u03D9'],
    ['\u03DA', '\u03DB'],
    ['\u03DC', '\u03DD'],
    ['\u03DE', '\u03DF'],
    ['\u03E0', '\u03E1'],
    ['\u03E2', '\u03E3'],
    ['\u03E4', '\u03E5'],
    ['\u03E6', '\u03E7'],
    ['\u03E8', '\u03E9'],
    ['\u03EA', '\u03EB'],
    ['\u03EC', '\u03ED'],
    ['\u03EE', '\u03EF'],
    ['\u03F0', '\u03BA'],
    ['\u03F1', '\u03C1'],
    ['\u03F4', '\u03B8'],
    ['\u03F5', '\u03B5'],
    ['\u03F7', '\u03F8'],
    ['\u03F9', '\u03F2'],
    ['\u03FA', '\u03FB'],
    ['\u03FD', '\u037B'],
    ['\u03FE', '\u037C'],
    ['\u03FF', '\u037D'],
    ['\u0400', '\u0450'],
    ['\u0401', '\u0451'],
    ['\u0402', '\u0452'],
    ['\u0403', '\u0453'],
    ['\u0404', '\u0454'],
    ['\u0405', '\u0455'],
    ['\u0406', '\u0456'],
    ['\u0407', '\u0457'],
    ['\u0408', '\u0458'],
    ['\u0409', '\u0459'],
    ['\u040A', '\u045A'],
    ['\u040B', '\u045B'],
    ['\u040C', '\u045C'],
    ['\u040D', '\u045D'],
    ['\u040E', '\u045E'],
    ['\u040F', '\u045F'],
    ['\u0410', '\u0430'],
    ['\u0411', '\u0431'],
    ['\u0412', '\u0432'],
    ['\u0413', '\u0433'],
    ['\u0414', '\u0434'],
    ['\u0415', '\u0435'],
    ['\u0416', '\u0436'],
    ['\u0417', '\u0437'],
    ['\u0418', '\u0438'],
    ['\u0419', '\u0439'],
    ['\u041A', '\u043A'],
    ['\u041B', '\u043B'],
    ['\u041C', '\u043C'],
    ['\u041D', '\u043D'],
    ['\u041E', '\u043E'],
    ['\u041F', '\u043F'],
    ['\u0420', '\u0440'],
    ['\u0421', '\u0441'],
    ['\u0422', '\u0442'],
    ['\u0423', '\u0443'],
    ['\u0424', '\u0444'],
    ['\u0425', '\u0445'],
    ['\u0426', '\u0446'],
    ['\u0427', '\u0447'],
    ['\u0428', '\u0448'],
    ['\u0429', '\u0449'],
    ['\u042A', '\u044A'],
    ['\u042B', '\u044B'],
    ['\u042C', '\u044C'],
    ['\u042D', '\u044D'],
    ['\u042E', '\u044E'],
    ['\u042F', '\u044F'],
    ['\u0460', '\u0461'],
    ['\u0462', '\u0463'],
    ['\u0464', '\u0465'],
    ['\u0466', '\u0467'],
    ['\u0468', '\u0469'],
    ['\u046A', '\u046B'],
    ['\u046C', '\u046D'],
    ['\u046E', '\u046F'],
    ['\u0470', '\u0471'],
    ['\u0472', '\u0473'],
    ['\u0474', '\u0475'],
    ['\u0476', '\u0477'],
    ['\u0478', '\u0479'],
    ['\u047A', '\u047B'],
    ['\u047C', '\u047D'],
    ['\u047E', '\u047F'],
    ['\u0480', '\u0481'],
    ['\u048A', '\u048B'],
    ['\u048C', '\u048D'],
    ['\u048E', '\u048F'],
    ['\u0490', '\u0491'],
    ['\u0492', '\u0493'],
    ['\u0494', '\u0495'],
    ['\u0496', '\u0497'],
    ['\u0498', '\u0499'],
    ['\u049A', '\u049B'],
    ['\u049C', '\u049D'],
    ['\u049E', '\u049F'],
    ['\u04A0', '\u04A1'],
    ['\u04A2', '\u04A3'],
    ['\u04A4', '\u04A5'],
    ['\u04A6', '\u04A7'],
    ['\u04A8', '\u04A9'],
    ['\u04AA', '\u04AB'],
    ['\u04AC', '\u04AD'],
    ['\u04AE', '\u04AF'],
    ['\u04B0', '\u04B1'],
    ['\u04B2', '\u04B3'],
    ['\u04B4', '\u04B5'],
    ['\u04B6', '\u04B7'],
    ['\u04B8', '\u04B9'],
    ['\u04BA', '\u04BB'],
    ['\u04BC', '\u04BD'],
    ['\u04BE', '\u04BF'],
    ['\u04C0', '\u04CF'],
    ['\u04C1', '\u04C2'],
    ['\u04C3', '\u04C4'],
    ['\u04C5', '\u04C6'],
    ['\u04C7', '\u04C8'],
    ['\u04C9', '\u04CA'],
    ['\u04CB', '\u04CC'],
    ['\u04CD', '\u04CE'],
    ['\u04D0', '\u04D1'],
    ['\u04D2', '\u04D3'],
    ['\u04D4', '\u04D5'],
    ['\u04D6', '\u04D7'],
    ['\u04D8', '\u04D9'],
    ['\u04DA', '\u04DB'],
    ['\u04DC', '\u04DD'],
    ['\u04DE', '\u04DF'],
    ['\u04E0', '\u04E1'],
    ['\u04E2', '\u04E3'],
    ['\u04E4', '\u04E5'],
    ['\u04E6', '\u04E7'],
    ['\u04E8', '\u04E9'],
    ['\u04EA', '\u04EB'],
    ['\u04EC', '\u04ED'],
    ['\u04EE', '\u04EF'],
    ['\u04F0', '\u04F1'],
    ['\u04F2', '\u04F3'],
    ['\u04F4', '\u04F5'],
    ['\u04F6', '\u04F7'],
    ['\u04F8', '\u04F9'],
    ['\u04FA', '\u04FB'],
    ['\u04FC', '\u04FD'],
    ['\u04FE', '\u04FF'],
    ['\u0500', '\u0501'],
    ['\u0502', '\u0503'],
    ['\u0504', '\u0505'],
    ['\u0506', '\u0507'],
    ['\u0508', '\u0509'],
    ['\u050A', '\u050B'],
    ['\u050C', '\u050D'],
    ['\u050E', '\u050F'],
    ['\u0510', '\u0511'],
    ['\u0512', '\u0513'],
    ['\u0514', '\u0515'],
    ['\u0516', '\u0517'],
    ['\u0518', '\u0519'],
    ['\u051A', '\u051B'],
    ['\u051C', '\u051D'],
    ['\u051E', '\u051F'],
    ['\u0520', '\u0521'],
    ['\u0522', '\u0523'],
    ['\u0524', '\u0525'],
    ['\u0526', '\u0527'],
    ['\u0528', '\u0529'],
    ['\u052A', '\u052B'],
    ['\u052C', '\u052D'],
    ['\u052E', '\u052F'],
    ['\u0531', '\u0561'],
    ['\u0532', '\u0562'],
    ['\u0533', '\u0563'],
    ['\u0534', '\u0564'],
    ['\u0535', '\u0565'],
    ['\u0536', '\u0566'],
    ['\u0537', '\u0567'],
    ['\u0538', '\u0568'],
    ['\u0539', '\u0569'],
    ['\u053A', '\u056A'],
    ['\u053B', '\u056B'],
    ['\u053C', '\u056C'],
    ['\u053D', '\u056D'],
    ['\u053E', '\u056E'],
    ['\u053F', '\u056F'],
    ['\u0540', '\u0570'],
    ['\u0541', '\u0571'],
    ['\u0542', '\u0572'],
    ['\u0543', '\u0573'],
    ['\u0544', '\u0574'],
    ['\u0545', '\u0575'],
    ['\u0546', '\u0576'],
    ['\u0547', '\u0577'],
    ['\u0548', '\u0578'],
    ['\u0549', '\u0579'],
    ['\u054A', '\u057A'],
    ['\u054B', '\u057B'],
    ['\u054C', '\u057C'],
    ['\u054D', '\u057D'],
    ['\u054E', '\u057E'],
    ['\u054F', '\u057F'],
    ['\u0550', '\u0580'],
    ['\u0551', '\u0581'],
    ['\u0552', '\u0582'],
    ['\u0553', '\u0583'],
    ['\u0554', '\u0584'],
    ['\u0555', '\u0585'],
    ['\u0556', '\u0586'],
    ['\u10A0', '\u2D00'],
    ['\u10A1', '\u2D01'],
    ['\u10A2', '\u2D02'],
    ['\u10A3', '\u2D03'],
    ['\u10A4', '\u2D04'],
    ['\u10A5', '\u2D05'],
    ['\u10A6', '\u2D06'],
    ['\u10A7', '\u2D07'],
    ['\u10A8', '\u2D08'],
    ['\u10A9', '\u2D09'],
    ['\u10AA', '\u2D0A'],
    ['\u10AB', '\u2D0B'],
    ['\u10AC', '\u2D0C'],
    ['\u10AD', '\u2D0D'],
    ['\u10AE', '\u2D0E'],
    ['\u10AF', '\u2D0F'],
    ['\u10B0', '\u2D10'],
    ['\u10B1', '\u2D11'],
    ['\u10B2', '\u2D12'],
    ['\u10B3', '\u2D13'],
    ['\u10B4', '\u2D14'],
    ['\u10B5', '\u2D15'],
    ['\u10B6', '\u2D16'],
    ['\u10B7', '\u2D17'],
    ['\u10B8', '\u2D18'],
    ['\u10B9', '\u2D19'],
    ['\u10BA', '\u2D1A'],
    ['\u10BB', '\u2D1B'],
    ['\u10BC', '\u2D1C'],
    ['\u10BD', '\u2D1D'],
    ['\u10BE', '\u2D1E'],
    ['\u10BF', '\u2D1F'],
    ['\u10C0', '\u2D20'],
    ['\u10C1', '\u2D21'],
    ['\u10C2', '\u2D22'],
    ['\u10C3', '\u2D23'],
    ['\u10C4', '\u2D24'],
    ['\u10C5', '\u2D25'],
    ['\u10C7', '\u2D27'],
    ['\u10CD', '\u2D2D'],
    ['\u13F8', '\u13F0'],
    ['\u13F9', '\u13F1'],
    ['\u13FA', '\u13F2'],
    ['\u13FB', '\u13F3'],
    ['\u13FC', '\u13F4'],
    ['\u13FD', '\u13F5'],
    ['\u1C80', '\u0432'],
    ['\u1C81', '\u0434'],
    ['\u1C82', '\u043E'],
    ['\u1C83', '\u0441'],
    ['\u1C84', '\u0442'],
    ['\u1C85', '\u0442'],
    ['\u1C86', '\u044A'],
    ['\u1C87', '\u0463'],
    ['\u1C88', '\uA64B'],
    ['\u1C90', '\u10D0'],
    ['\u1C91', '\u10D1'],
    ['\u1C92', '\u10D2'],
    ['\u1C93', '\u10D3'],
    ['\u1C94', '\u10D4'],
    ['\u1C95', '\u10D5'],
    ['\u1C96', '\u10D6'],
    ['\u1C97', '\u10D7'],
    ['\u1C98', '\u10D8'],
    ['\u1C99', '\u10D9'],
    ['\u1C9A', '\u10DA'],
    ['\u1C9B', '\u10DB'],
    ['\u1C9C', '\u10DC'],
    ['\u1C9D', '\u10DD'],
    ['\u1C9E', '\u10DE'],
    ['\u1C9F', '\u10DF'],
    ['\u1CA0', '\u10E0'],
    ['\u1CA1', '\u10E1'],
    ['\u1CA2', '\u10E2'],
    ['\u1CA3', '\u10E3'],
    ['\u1CA4', '\u10E4'],
    ['\u1CA5', '\u10E5'],
    ['\u1CA6', '\u10E6'],
    ['\u1CA7', '\u10E7'],
    ['\u1CA8', '\u10E8'],
    ['\u1CA9', '\u10E9'],
    ['\u1CAA', '\u10EA'],
    ['\u1CAB', '\u10EB'],
    ['\u1CAC', '\u10EC'],
    ['\u1CAD', '\u10ED'],
    ['\u1CAE', '\u10EE'],
    ['\u1CAF', '\u10EF'],
    ['\u1CB0', '\u10F0'],
    ['\u1CB1', '\u10F1'],
    ['\u1CB2', '\u10F2'],
    ['\u1CB3', '\u10F3'],
    ['\u1CB4', '\u10F4'],
    ['\u1CB5', '\u10F5'],
    ['\u1CB6', '\u10F6'],
    ['\u1CB7', '\u10F7'],
    ['\u1CB8', '\u10F8'],
    ['\u1CB9', '\u10F9'],
    ['\u1CBA', '\u10FA'],
    ['\u1CBD', '\u10FD'],
    ['\u1CBE', '\u10FE'],
    ['\u1CBF', '\u10FF'],
    ['\u1E00', '\u1E01'],
    ['\u1E02', '\u1E03'],
    ['\u1E04', '\u1E05'],
    ['\u1E06', '\u1E07'],
    ['\u1E08', '\u1E09'],
    ['\u1E0A', '\u1E0B'],
    ['\u1E0C', '\u1E0D'],
    ['\u1E0E', '\u1E0F'],
    ['\u1E10', '\u1E11'],
    ['\u1E12', '\u1E13'],
    ['\u1E14', '\u1E15'],
    ['\u1E16', '\u1E17'],
    ['\u1E18', '\u1E19'],
    ['\u1E1A', '\u1E1B'],
    ['\u1E1C', '\u1E1D'],
    ['\u1E1E', '\u1E1F'],
    ['\u1E20', '\u1E21'],
    ['\u1E22', '\u1E23'],
    ['\u1E24', '\u1E25'],
    ['\u1E26', '\u1E27'],
    ['\u1E28', '\u1E29'],
    ['\u1E2A', '\u1E2B'],
    ['\u1E2C', '\u1E2D'],
    ['\u1E2E', '\u1E2F'],
    ['\u1E30', '\u1E31'],
    ['\u1E32', '\u1E33'],
    ['\u1E34', '\u1E35'],
    ['\u1E36', '\u1E37'],
    ['\u1E38', '\u1E39'],
    ['\u1E3A', '\u1E3B'],
    ['\u1E3C', '\u1E3D'],
    ['\u1E3E', '\u1E3F'],
    ['\u1E40', '\u1E41'],
    ['\u1E42', '\u1E43'],
    ['\u1E44', '\u1E45'],
    ['\u1E46', '\u1E47'],
    ['\u1E48', '\u1E49'],
    ['\u1E4A', '\u1E4B'],
    ['\u1E4C', '\u1E4D'],
    ['\u1E4E', '\u1E4F'],
    ['\u1E50', '\u1E51'],
    ['\u1E52', '\u1E53'],
    ['\u1E54', '\u1E55'],
    ['\u1E56', '\u1E57'],
    ['\u1E58', '\u1E59'],
    ['\u1E5A', '\u1E5B'],
    ['\u1E5C', '\u1E5D'],
    ['\u1E5E', '\u1E5F'],
    ['\u1E60', '\u1E61'],
    ['\u1E62', '\u1E63'],
    ['\u1E64', '\u1E65'],
    ['\u1E66', '\u1E67'],
    ['\u1E68', '\u1E69'],
    ['\u1E6A', '\u1E6B'],
    ['\u1E6C', '\u1E6D'],
    ['\u1E6E', '\u1E6F'],
    ['\u1E70', '\u1E71'],
    ['\u1E72', '\u1E73'],
    ['\u1E74', '\u1E75'],
    ['\u1E76', '\u1E77'],
    ['\u1E78', '\u1E79'],
    ['\u1E7A', '\u1E7B'],
    ['\u1E7C', '\u1E7D'],
    ['\u1E7E', '\u1E7F'],
    ['\u1E80', '\u1E81'],
    ['\u1E82', '\u1E83'],
    ['\u1E84', '\u1E85'],
    ['\u1E86', '\u1E87'],
    ['\u1E88', '\u1E89'],
    ['\u1E8A', '\u1E8B'],
    ['\u1E8C', '\u1E8D'],
    ['\u1E8E', '\u1E8F'],
    ['\u1E90', '\u1E91'],
    ['\u1E92', '\u1E93'],
    ['\u1E94', '\u1E95'],
    ['\u1E9B', '\u1E61'],
    ['\u1EA0', '\u1EA1'],
    ['\u1EA2', '\u1EA3'],
    ['\u1EA4', '\u1EA5'],
    ['\u1EA6', '\u1EA7'],
    ['\u1EA8', '\u1EA9'],
    ['\u1EAA', '\u1EAB'],
    ['\u1EAC', '\u1EAD'],
    ['\u1EAE', '\u1EAF'],
    ['\u1EB0', '\u1EB1'],
    ['\u1EB2', '\u1EB3'],
    ['\u1EB4', '\u1EB5'],
    ['\u1EB6', '\u1EB7'],
    ['\u1EB8', '\u1EB9'],
    ['\u1EBA', '\u1EBB'],
    ['\u1EBC', '\u1EBD'],
    ['\u1EBE', '\u1EBF'],
    ['\u1EC0', '\u1EC1'],
    ['\u1EC2', '\u1EC3'],
    ['\u1EC4', '\u1EC5'],
    ['\u1EC6', '\u1EC7'],
    ['\u1EC8', '\u1EC9'],
    ['\u1ECA', '\u1ECB'],
    ['\u1ECC', '\u1ECD'],
    ['\u1ECE', '\u1ECF'],
    ['\u1ED0', '\u1ED1'],
    ['\u1ED2', '\u1ED3'],
    ['\u1ED4', '\u1ED5'],
    ['\u1ED6', '\u1ED7'],
    ['\u1ED8', '\u1ED9'],
    ['\u1EDA', '\u1EDB'],
    ['\u1EDC', '\u1EDD'],
    ['\u1EDE', '\u1EDF'],
    ['\u1EE0', '\u1EE1'],
    ['\u1EE2', '\u1EE3'],
    ['\u1EE4', '\u1EE5'],
    ['\u1EE6', '\u1EE7'],
    ['\u1EE8', '\u1EE9'],
    ['\u1EEA', '\u1EEB'],
    ['\u1EEC', '\u1EED'],
    ['\u1EEE', '\u1EEF'],
    ['\u1EF0', '\u1EF1'],
    ['\u1EF2', '\u1EF3'],
    ['\u1EF4', '\u1EF5'],
    ['\u1EF6', '\u1EF7'],
    ['\u1EF8', '\u1EF9'],
    ['\u1EFA', '\u1EFB'],
    ['\u1EFC', '\u1EFD'],
    ['\u1EFE', '\u1EFF'],
    ['\u1F08', '\u1F00'],
    ['\u1F09', '\u1F01'],
    ['\u1F0A', '\u1F02'],
    ['\u1F0B', '\u1F03'],
    ['\u1F0C', '\u1F04'],
    ['\u1F0D', '\u1F05'],
    ['\u1F0E', '\u1F06'],
    ['\u1F0F', '\u1F07'],
    ['\u1F18', '\u1F10'],
    ['\u1F19', '\u1F11'],
    ['\u1F1A', '\u1F12'],
    ['\u1F1B', '\u1F13'],
    ['\u1F1C', '\u1F14'],
    ['\u1F1D', '\u1F15'],
    ['\u1F28', '\u1F20'],
    ['\u1F29', '\u1F21'],
    ['\u1F2A', '\u1F22'],
    ['\u1F2B', '\u1F23'],
    ['\u1F2C', '\u1F24'],
    ['\u1F2D', '\u1F25'],
    ['\u1F2E', '\u1F26'],
    ['\u1F2F', '\u1F27'],
    ['\u1F38', '\u1F30'],
    ['\u1F39', '\u1F31'],
    ['\u1F3A', '\u1F32'],
    ['\u1F3B', '\u1F33'],
    ['\u1F3C', '\u1F34'],
    ['\u1F3D', '\u1F35'],
    ['\u1F3E', '\u1F36'],
    ['\u1F3F', '\u1F37'],
    ['\u1F48', '\u1F40'],
    ['\u1F49', '\u1F41'],
    ['\u1F4A', '\u1F42'],
    ['\u1F4B', '\u1F43'],
    ['\u1F4C', '\u1F44'],
    ['\u1F4D', '\u1F45'],
    ['\u1F59', '\u1F51'],
    ['\u1F5B', '\u1F53'],
    ['\u1F5D', '\u1F55'],
    ['\u1F5F', '\u1F57'],
    ['\u1F68', '\u1F60'],
    ['\u1F69', '\u1F61'],
    ['\u1F6A', '\u1F62'],
    ['\u1F6B', '\u1F63'],
    ['\u1F6C', '\u1F64'],
    ['\u1F6D', '\u1F65'],
    ['\u1F6E', '\u1F66'],
    ['\u1F6F', '\u1F67'],
    ['\u1FB8', '\u1FB0'],
    ['\u1FB9', '\u1FB1'],
    ['\u1FBA', '\u1F70'],
    ['\u1FBB', '\u1F71'],
    ['\u1FBE', '\u03B9'],
    ['\u1FC8', '\u1F72'],
    ['\u1FC9', '\u1F73'],
    ['\u1FCA', '\u1F74'],
    ['\u1FCB', '\u1F75'],
    ['\u1FD8', '\u1FD0'],
    ['\u1FD9', '\u1FD1'],
    ['\u1FDA', '\u1F76'],
    ['\u1FDB', '\u1F77'],
    ['\u1FE8', '\u1FE0'],
    ['\u1FE9', '\u1FE1'],
    ['\u1FEA', '\u1F7A'],
    ['\u1FEB', '\u1F7B'],
    ['\u1FEC', '\u1FE5'],
    ['\u1FF8', '\u1F78'],
    ['\u1FF9', '\u1F79'],
    ['\u1FFA', '\u1F7C'],
    ['\u1FFB', '\u1F7D'],
    ['\u2126', '\u03C9'],
    ['\u212A', 'k'],
    ['\u212B', '\xE5'],
    ['\u2132', '\u214E'],
    ['\u2160', '\u2170'],
    ['\u2161', '\u2171'],
    ['\u2162', '\u2172'],
    ['\u2163', '\u2173'],
    ['\u2164', '\u2174'],
    ['\u2165', '\u2175'],
    ['\u2166', '\u2176'],
    ['\u2167', '\u2177'],
    ['\u2168', '\u2178'],
    ['\u2169', '\u2179'],
    ['\u216A', '\u217A'],
    ['\u216B', '\u217B'],
    ['\u216C', '\u217C'],
    ['\u216D', '\u217D'],
    ['\u216E', '\u217E'],
    ['\u216F', '\u217F'],
    ['\u2183', '\u2184'],
    ['\u24B6', '\u24D0'],
    ['\u24B7', '\u24D1'],
    ['\u24B8', '\u24D2'],
    ['\u24B9', '\u24D3'],
    ['\u24BA', '\u24D4'],
    ['\u24BB', '\u24D5'],
    ['\u24BC', '\u24D6'],
    ['\u24BD', '\u24D7'],
    ['\u24BE', '\u24D8'],
    ['\u24BF', '\u24D9'],
    ['\u24C0', '\u24DA'],
    ['\u24C1', '\u24DB'],
    ['\u24C2', '\u24DC'],
    ['\u24C3', '\u24DD'],
    ['\u24C4', '\u24DE'],
    ['\u24C5', '\u24DF'],
    ['\u24C6', '\u24E0'],
    ['\u24C7', '\u24E1'],
    ['\u24C8', '\u24E2'],
    ['\u24C9', '\u24E3'],
    ['\u24CA', '\u24E4'],
    ['\u24CB', '\u24E5'],
    ['\u24CC', '\u24E6'],
    ['\u24CD', '\u24E7'],
    ['\u24CE', '\u24E8'],
    ['\u24CF', '\u24E9'],
    ['\u2C00', '\u2C30'],
    ['\u2C01', '\u2C31'],
    ['\u2C02', '\u2C32'],
    ['\u2C03', '\u2C33'],
    ['\u2C04', '\u2C34'],
    ['\u2C05', '\u2C35'],
    ['\u2C06', '\u2C36'],
    ['\u2C07', '\u2C37'],
    ['\u2C08', '\u2C38'],
    ['\u2C09', '\u2C39'],
    ['\u2C0A', '\u2C3A'],
    ['\u2C0B', '\u2C3B'],
    ['\u2C0C', '\u2C3C'],
    ['\u2C0D', '\u2C3D'],
    ['\u2C0E', '\u2C3E'],
    ['\u2C0F', '\u2C3F'],
    ['\u2C10', '\u2C40'],
    ['\u2C11', '\u2C41'],
    ['\u2C12', '\u2C42'],
    ['\u2C13', '\u2C43'],
    ['\u2C14', '\u2C44'],
    ['\u2C15', '\u2C45'],
    ['\u2C16', '\u2C46'],
    ['\u2C17', '\u2C47'],
    ['\u2C18', '\u2C48'],
    ['\u2C19', '\u2C49'],
    ['\u2C1A', '\u2C4A'],
    ['\u2C1B', '\u2C4B'],
    ['\u2C1C', '\u2C4C'],
    ['\u2C1D', '\u2C4D'],
    ['\u2C1E', '\u2C4E'],
    ['\u2C1F', '\u2C4F'],
    ['\u2C20', '\u2C50'],
    ['\u2C21', '\u2C51'],
    ['\u2C22', '\u2C52'],
    ['\u2C23', '\u2C53'],
    ['\u2C24', '\u2C54'],
    ['\u2C25', '\u2C55'],
    ['\u2C26', '\u2C56'],
    ['\u2C27', '\u2C57'],
    ['\u2C28', '\u2C58'],
    ['\u2C29', '\u2C59'],
    ['\u2C2A', '\u2C5A'],
    ['\u2C2B', '\u2C5B'],
    ['\u2C2C', '\u2C5C'],
    ['\u2C2D', '\u2C5D'],
    ['\u2C2E', '\u2C5E'],
    ['\u2C2F', '\u2C5F'],
    ['\u2C60', '\u2C61'],
    ['\u2C62', '\u026B'],
    ['\u2C63', '\u1D7D'],
    ['\u2C64', '\u027D'],
    ['\u2C67', '\u2C68'],
    ['\u2C69', '\u2C6A'],
    ['\u2C6B', '\u2C6C'],
    ['\u2C6D', '\u0251'],
    ['\u2C6E', '\u0271'],
    ['\u2C6F', '\u0250'],
    ['\u2C70', '\u0252'],
    ['\u2C72', '\u2C73'],
    ['\u2C75', '\u2C76'],
    ['\u2C7E', '\u023F'],
    ['\u2C7F', '\u0240'],
    ['\u2C80', '\u2C81'],
    ['\u2C82', '\u2C83'],
    ['\u2C84', '\u2C85'],
    ['\u2C86', '\u2C87'],
    ['\u2C88', '\u2C89'],
    ['\u2C8A', '\u2C8B'],
    ['\u2C8C', '\u2C8D'],
    ['\u2C8E', '\u2C8F'],
    ['\u2C90', '\u2C91'],
    ['\u2C92', '\u2C93'],
    ['\u2C94', '\u2C95'],
    ['\u2C96', '\u2C97'],
    ['\u2C98', '\u2C99'],
    ['\u2C9A', '\u2C9B'],
    ['\u2C9C', '\u2C9D'],
    ['\u2C9E', '\u2C9F'],
    ['\u2CA0', '\u2CA1'],
    ['\u2CA2', '\u2CA3'],
    ['\u2CA4', '\u2CA5'],
    ['\u2CA6', '\u2CA7'],
    ['\u2CA8', '\u2CA9'],
    ['\u2CAA', '\u2CAB'],
    ['\u2CAC', '\u2CAD'],
    ['\u2CAE', '\u2CAF'],
    ['\u2CB0', '\u2CB1'],
    ['\u2CB2', '\u2CB3'],
    ['\u2CB4', '\u2CB5'],
    ['\u2CB6', '\u2CB7'],
    ['\u2CB8', '\u2CB9'],
    ['\u2CBA', '\u2CBB'],
    ['\u2CBC', '\u2CBD'],
    ['\u2CBE', '\u2CBF'],
    ['\u2CC0', '\u2CC1'],
    ['\u2CC2', '\u2CC3'],
    ['\u2CC4', '\u2CC5'],
    ['\u2CC6', '\u2CC7'],
    ['\u2CC8', '\u2CC9'],
    ['\u2CCA', '\u2CCB'],
    ['\u2CCC', '\u2CCD'],
    ['\u2CCE', '\u2CCF'],
    ['\u2CD0', '\u2CD1'],
    ['\u2CD2', '\u2CD3'],
    ['\u2CD4', '\u2CD5'],
    ['\u2CD6', '\u2CD7'],
    ['\u2CD8', '\u2CD9'],
    ['\u2CDA', '\u2CDB'],
    ['\u2CDC', '\u2CDD'],
    ['\u2CDE', '\u2CDF'],
    ['\u2CE0', '\u2CE1'],
    ['\u2CE2', '\u2CE3'],
    ['\u2CEB', '\u2CEC'],
    ['\u2CED', '\u2CEE'],
    ['\u2CF2', '\u2CF3'],
    ['\uA640', '\uA641'],
    ['\uA642', '\uA643'],
    ['\uA644', '\uA645'],
    ['\uA646', '\uA647'],
    ['\uA648', '\uA649'],
    ['\uA64A', '\uA64B'],
    ['\uA64C', '\uA64D'],
    ['\uA64E', '\uA64F'],
    ['\uA650', '\uA651'],
    ['\uA652', '\uA653'],
    ['\uA654', '\uA655'],
    ['\uA656', '\uA657'],
    ['\uA658', '\uA659'],
    ['\uA65A', '\uA65B'],
    ['\uA65C', '\uA65D'],
    ['\uA65E', '\uA65F'],
    ['\uA660', '\uA661'],
    ['\uA662', '\uA663'],
    ['\uA664', '\uA665'],
    ['\uA666', '\uA667'],
    ['\uA668', '\uA669'],
    ['\uA66A', '\uA66B'],
    ['\uA66C', '\uA66D'],
    ['\uA680', '\uA681'],
    ['\uA682', '\uA683'],
    ['\uA684', '\uA685'],
    ['\uA686', '\uA687'],
    ['\uA688', '\uA689'],
    ['\uA68A', '\uA68B'],
    ['\uA68C', '\uA68D'],
    ['\uA68E', '\uA68F'],
    ['\uA690', '\uA691'],
    ['\uA692', '\uA693'],
    ['\uA694', '\uA695'],
    ['\uA696', '\uA697'],
    ['\uA698', '\uA699'],
    ['\uA69A', '\uA69B'],
    ['\uA722', '\uA723'],
    ['\uA724', '\uA725'],
    ['\uA726', '\uA727'],
    ['\uA728', '\uA729'],
    ['\uA72A', '\uA72B'],
    ['\uA72C', '\uA72D'],
    ['\uA72E', '\uA72F'],
    ['\uA732', '\uA733'],
    ['\uA734', '\uA735'],
    ['\uA736', '\uA737'],
    ['\uA738', '\uA739'],
    ['\uA73A', '\uA73B'],
    ['\uA73C', '\uA73D'],
    ['\uA73E', '\uA73F'],
    ['\uA740', '\uA741'],
    ['\uA742', '\uA743'],
    ['\uA744', '\uA745'],
    ['\uA746', '\uA747'],
    ['\uA748', '\uA749'],
    ['\uA74A', '\uA74B'],
    ['\uA74C', '\uA74D'],
    ['\uA74E', '\uA74F'],
    ['\uA750', '\uA751'],
    ['\uA752', '\uA753'],
    ['\uA754', '\uA755'],
    ['\uA756', '\uA757'],
    ['\uA758', '\uA759'],
    ['\uA75A', '\uA75B'],
    ['\uA75C', '\uA75D'],
    ['\uA75E', '\uA75F'],
    ['\uA760', '\uA761'],
    ['\uA762', '\uA763'],
    ['\uA764', '\uA765'],
    ['\uA766', '\uA767'],
    ['\uA768', '\uA769'],
    ['\uA76A', '\uA76B'],
    ['\uA76C', '\uA76D'],
    ['\uA76E', '\uA76F'],
    ['\uA779', '\uA77A'],
    ['\uA77B', '\uA77C'],
    ['\uA77D', '\u1D79'],
    ['\uA77E', '\uA77F'],
    ['\uA780', '\uA781'],
    ['\uA782', '\uA783'],
    ['\uA784', '\uA785'],
    ['\uA786', '\uA787'],
    ['\uA78B', '\uA78C'],
    ['\uA78D', '\u0265'],
    ['\uA790', '\uA791'],
    ['\uA792', '\uA793'],
    ['\uA796', '\uA797'],
    ['\uA798', '\uA799'],
    ['\uA79A', '\uA79B'],
    ['\uA79C', '\uA79D'],
    ['\uA79E', '\uA79F'],
    ['\uA7A0', '\uA7A1'],
    ['\uA7A2', '\uA7A3'],
    ['\uA7A4', '\uA7A5'],
    ['\uA7A6', '\uA7A7'],
    ['\uA7A8', '\uA7A9'],
    ['\uA7AA', '\u0266'],
    ['\uA7AB', '\u025C'],
    ['\uA7AC', '\u0261'],
    ['\uA7AD', '\u026C'],
    ['\uA7AE', '\u026A'],
    ['\uA7B0', '\u029E'],
    ['\uA7B1', '\u0287'],
    ['\uA7B2', '\u029D'],
    ['\uA7B3', '\uAB53'],
    ['\uA7B4', '\uA7B5'],
    ['\uA7B6', '\uA7B7'],
    ['\uA7B8', '\uA7B9'],
    ['\uA7BA', '\uA7BB'],
    ['\uA7BC', '\uA7BD'],
    ['\uA7BE', '\uA7BF'],
    ['\uA7C0', '\uA7C1'],
    ['\uA7C2', '\uA7C3'],
    ['\uA7C4', '\uA794'],
    ['\uA7C5', '\u0282'],
    ['\uA7C6', '\u1D8E'],
    ['\uA7C7', '\uA7C8'],
    ['\uA7C9', '\uA7CA'],
    ['\uA7D0', '\uA7D1'],
    ['\uA7D6', '\uA7D7'],
    ['\uA7D8', '\uA7D9'],
    ['\uA7F5', '\uA7F6'],
    ['\uAB70', '\u13A0'],
    ['\uAB71', '\u13A1'],
    ['\uAB72', '\u13A2'],
    ['\uAB73', '\u13A3'],
    ['\uAB74', '\u13A4'],
    ['\uAB75', '\u13A5'],
    ['\uAB76', '\u13A6'],
    ['\uAB77', '\u13A7'],
    ['\uAB78', '\u13A8'],
    ['\uAB79', '\u13A9'],
    ['\uAB7A', '\u13AA'],
    ['\uAB7B', '\u13AB'],
    ['\uAB7C', '\u13AC'],
    ['\uAB7D', '\u13AD'],
    ['\uAB7E', '\u13AE'],
    ['\uAB7F', '\u13AF'],
    ['\uAB80', '\u13B0'],
    ['\uAB81', '\u13B1'],
    ['\uAB82', '\u13B2'],
    ['\uAB83', '\u13B3'],
    ['\uAB84', '\u13B4'],
    ['\uAB85', '\u13B5'],
    ['\uAB86', '\u13B6'],
    ['\uAB87', '\u13B7'],
    ['\uAB88', '\u13B8'],
    ['\uAB89', '\u13B9'],
    ['\uAB8A', '\u13BA'],
    ['\uAB8B', '\u13BB'],
    ['\uAB8C', '\u13BC'],
    ['\uAB8D', '\u13BD'],
    ['\uAB8E', '\u13BE'],
    ['\uAB8F', '\u13BF'],
    ['\uAB90', '\u13C0'],
    ['\uAB91', '\u13C1'],
    ['\uAB92', '\u13C2'],
    ['\uAB93', '\u13C3'],
    ['\uAB94', '\u13C4'],
    ['\uAB95', '\u13C5'],
    ['\uAB96', '\u13C6'],
    ['\uAB97', '\u13C7'],
    ['\uAB98', '\u13C8'],
    ['\uAB99', '\u13C9'],
    ['\uAB9A', '\u13CA'],
    ['\uAB9B', '\u13CB'],
    ['\uAB9C', '\u13CC'],
    ['\uAB9D', '\u13CD'],
    ['\uAB9E', '\u13CE'],
    ['\uAB9F', '\u13CF'],
    ['\uABA0', '\u13D0'],
    ['\uABA1', '\u13D1'],
    ['\uABA2', '\u13D2'],
    ['\uABA3', '\u13D3'],
    ['\uABA4', '\u13D4'],
    ['\uABA5', '\u13D5'],
    ['\uABA6', '\u13D6'],
    ['\uABA7', '\u13D7'],
    ['\uABA8', '\u13D8'],
    ['\uABA9', '\u13D9'],
    ['\uABAA', '\u13DA'],
    ['\uABAB', '\u13DB'],
    ['\uABAC', '\u13DC'],
    ['\uABAD', '\u13DD'],
    ['\uABAE', '\u13DE'],
    ['\uABAF', '\u13DF'],
    ['\uABB0', '\u13E0'],
    ['\uABB1', '\u13E1'],
    ['\uABB2', '\u13E2'],
    ['\uABB3', '\u13E3'],
    ['\uABB4', '\u13E4'],
    ['\uABB5', '\u13E5'],
    ['\uABB6', '\u13E6'],
    ['\uABB7', '\u13E7'],
    ['\uABB8', '\u13E8'],
    ['\uABB9', '\u13E9'],
    ['\uABBA', '\u13EA'],
    ['\uABBB', '\u13EB'],
    ['\uABBC', '\u13EC'],
    ['\uABBD', '\u13ED'],
    ['\uABBE', '\u13EE'],
    ['\uABBF', '\u13EF'],
    ['\uFF21', '\uFF41'],
    ['\uFF22', '\uFF42'],
    ['\uFF23', '\uFF43'],
    ['\uFF24', '\uFF44'],
    ['\uFF25', '\uFF45'],
    ['\uFF26', '\uFF46'],
    ['\uFF27', '\uFF47'],
    ['\uFF28', '\uFF48'],
    ['\uFF29', '\uFF49'],
    ['\uFF2A', '\uFF4A'],
    ['\uFF2B', '\uFF4B'],
    ['\uFF2C', '\uFF4C'],
    ['\uFF2D', '\uFF4D'],
    ['\uFF2E', '\uFF4E'],
    ['\uFF2F', '\uFF4F'],
    ['\uFF30', '\uFF50'],
    ['\uFF31', '\uFF51'],
    ['\uFF32', '\uFF52'],
    ['\uFF33', '\uFF53'],
    ['\uFF34', '\uFF54'],
    ['\uFF35', '\uFF55'],
    ['\uFF36', '\uFF56'],
    ['\uFF37', '\uFF57'],
    ['\uFF38', '\uFF58'],
    ['\uFF39', '\uFF59'],
    ['\uFF3A', '\uFF5A'],
    ['\uD801\uDC00', '\uD801\uDC28'],
    ['\uD801\uDC01', '\uD801\uDC29'],
    ['\uD801\uDC02', '\uD801\uDC2A'],
    ['\uD801\uDC03', '\uD801\uDC2B'],
    ['\uD801\uDC04', '\uD801\uDC2C'],
    ['\uD801\uDC05', '\uD801\uDC2D'],
    ['\uD801\uDC06', '\uD801\uDC2E'],
    ['\uD801\uDC07', '\uD801\uDC2F'],
    ['\uD801\uDC08', '\uD801\uDC30'],
    ['\uD801\uDC09', '\uD801\uDC31'],
    ['\uD801\uDC0A', '\uD801\uDC32'],
    ['\uD801\uDC0B', '\uD801\uDC33'],
    ['\uD801\uDC0C', '\uD801\uDC34'],
    ['\uD801\uDC0D', '\uD801\uDC35'],
    ['\uD801\uDC0E', '\uD801\uDC36'],
    ['\uD801\uDC0F', '\uD801\uDC37'],
    ['\uD801\uDC10', '\uD801\uDC38'],
    ['\uD801\uDC11', '\uD801\uDC39'],
    ['\uD801\uDC12', '\uD801\uDC3A'],
    ['\uD801\uDC13', '\uD801\uDC3B'],
    ['\uD801\uDC14', '\uD801\uDC3C'],
    ['\uD801\uDC15', '\uD801\uDC3D'],
    ['\uD801\uDC16', '\uD801\uDC3E'],
    ['\uD801\uDC17', '\uD801\uDC3F'],
    ['\uD801\uDC18', '\uD801\uDC40'],
    ['\uD801\uDC19', '\uD801\uDC41'],
    ['\uD801\uDC1A', '\uD801\uDC42'],
    ['\uD801\uDC1B', '\uD801\uDC43'],
    ['\uD801\uDC1C', '\uD801\uDC44'],
    ['\uD801\uDC1D', '\uD801\uDC45'],
    ['\uD801\uDC1E', '\uD801\uDC46'],
    ['\uD801\uDC1F', '\uD801\uDC47'],
    ['\uD801\uDC20', '\uD801\uDC48'],
    ['\uD801\uDC21', '\uD801\uDC49'],
    ['\uD801\uDC22', '\uD801\uDC4A'],
    ['\uD801\uDC23', '\uD801\uDC4B'],
    ['\uD801\uDC24', '\uD801\uDC4C'],
    ['\uD801\uDC25', '\uD801\uDC4D'],
    ['\uD801\uDC26', '\uD801\uDC4E'],
    ['\uD801\uDC27', '\uD801\uDC4F'],
    ['\uD801\uDCB0', '\uD801\uDCD8'],
    ['\uD801\uDCB1', '\uD801\uDCD9'],
    ['\uD801\uDCB2', '\uD801\uDCDA'],
    ['\uD801\uDCB3', '\uD801\uDCDB'],
    ['\uD801\uDCB4', '\uD801\uDCDC'],
    ['\uD801\uDCB5', '\uD801\uDCDD'],
    ['\uD801\uDCB6', '\uD801\uDCDE'],
    ['\uD801\uDCB7', '\uD801\uDCDF'],
    ['\uD801\uDCB8', '\uD801\uDCE0'],
    ['\uD801\uDCB9', '\uD801\uDCE1'],
    ['\uD801\uDCBA', '\uD801\uDCE2'],
    ['\uD801\uDCBB', '\uD801\uDCE3'],
    ['\uD801\uDCBC', '\uD801\uDCE4'],
    ['\uD801\uDCBD', '\uD801\uDCE5'],
    ['\uD801\uDCBE', '\uD801\uDCE6'],
    ['\uD801\uDCBF', '\uD801\uDCE7'],
    ['\uD801\uDCC0', '\uD801\uDCE8'],
    ['\uD801\uDCC1', '\uD801\uDCE9'],
    ['\uD801\uDCC2', '\uD801\uDCEA'],
    ['\uD801\uDCC3', '\uD801\uDCEB'],
    ['\uD801\uDCC4', '\uD801\uDCEC'],
    ['\uD801\uDCC5', '\uD801\uDCED'],
    ['\uD801\uDCC6', '\uD801\uDCEE'],
    ['\uD801\uDCC7', '\uD801\uDCEF'],
    ['\uD801\uDCC8', '\uD801\uDCF0'],
    ['\uD801\uDCC9', '\uD801\uDCF1'],
    ['\uD801\uDCCA', '\uD801\uDCF2'],
    ['\uD801\uDCCB', '\uD801\uDCF3'],
    ['\uD801\uDCCC', '\uD801\uDCF4'],
    ['\uD801\uDCCD', '\uD801\uDCF5'],
    ['\uD801\uDCCE', '\uD801\uDCF6'],
    ['\uD801\uDCCF', '\uD801\uDCF7'],
    ['\uD801\uDCD0', '\uD801\uDCF8'],
    ['\uD801\uDCD1', '\uD801\uDCF9'],
    ['\uD801\uDCD2', '\uD801\uDCFA'],
    ['\uD801\uDCD3', '\uD801\uDCFB'],
    ['\uD801\uDD70', '\uD801\uDD97'],
    ['\uD801\uDD71', '\uD801\uDD98'],
    ['\uD801\uDD72', '\uD801\uDD99'],
    ['\uD801\uDD73', '\uD801\uDD9A'],
    ['\uD801\uDD74', '\uD801\uDD9B'],
    ['\uD801\uDD75', '\uD801\uDD9C'],
    ['\uD801\uDD76', '\uD801\uDD9D'],
    ['\uD801\uDD77', '\uD801\uDD9E'],
    ['\uD801\uDD78', '\uD801\uDD9F'],
    ['\uD801\uDD79', '\uD801\uDDA0'],
    ['\uD801\uDD7A', '\uD801\uDDA1'],
    ['\uD801\uDD7C', '\uD801\uDDA3'],
    ['\uD801\uDD7D', '\uD801\uDDA4'],
    ['\uD801\uDD7E', '\uD801\uDDA5'],
    ['\uD801\uDD7F', '\uD801\uDDA6'],
    ['\uD801\uDD80', '\uD801\uDDA7'],
    ['\uD801\uDD81', '\uD801\uDDA8'],
    ['\uD801\uDD82', '\uD801\uDDA9'],
    ['\uD801\uDD83', '\uD801\uDDAA'],
    ['\uD801\uDD84', '\uD801\uDDAB'],
    ['\uD801\uDD85', '\uD801\uDDAC'],
    ['\uD801\uDD86', '\uD801\uDDAD'],
    ['\uD801\uDD87', '\uD801\uDDAE'],
    ['\uD801\uDD88', '\uD801\uDDAF'],
    ['\uD801\uDD89', '\uD801\uDDB0'],
    ['\uD801\uDD8A', '\uD801\uDDB1'],
    ['\uD801\uDD8C', '\uD801\uDDB3'],
    ['\uD801\uDD8D', '\uD801\uDDB4'],
    ['\uD801\uDD8E', '\uD801\uDDB5'],
    ['\uD801\uDD8F', '\uD801\uDDB6'],
    ['\uD801\uDD90', '\uD801\uDDB7'],
    ['\uD801\uDD91', '\uD801\uDDB8'],
    ['\uD801\uDD92', '\uD801\uDDB9'],
    ['\uD801\uDD94', '\uD801\uDDBB'],
    ['\uD801\uDD95', '\uD801\uDDBC'],
    ['\uD803\uDC80', '\uD803\uDCC0'],
    ['\uD803\uDC81', '\uD803\uDCC1'],
    ['\uD803\uDC82', '\uD803\uDCC2'],
    ['\uD803\uDC83', '\uD803\uDCC3'],
    ['\uD803\uDC84', '\uD803\uDCC4'],
    ['\uD803\uDC85', '\uD803\uDCC5'],
    ['\uD803\uDC86', '\uD803\uDCC6'],
    ['\uD803\uDC87', '\uD803\uDCC7'],
    ['\uD803\uDC88', '\uD803\uDCC8'],
    ['\uD803\uDC89', '\uD803\uDCC9'],
    ['\uD803\uDC8A', '\uD803\uDCCA'],
    ['\uD803\uDC8B', '\uD803\uDCCB'],
    ['\uD803\uDC8C', '\uD803\uDCCC'],
    ['\uD803\uDC8D', '\uD803\uDCCD'],
    ['\uD803\uDC8E', '\uD803\uDCCE'],
    ['\uD803\uDC8F', '\uD803\uDCCF'],
    ['\uD803\uDC90', '\uD803\uDCD0'],
    ['\uD803\uDC91', '\uD803\uDCD1'],
    ['\uD803\uDC92', '\uD803\uDCD2'],
    ['\uD803\uDC93', '\uD803\uDCD3'],
    ['\uD803\uDC94', '\uD803\uDCD4'],
    ['\uD803\uDC95', '\uD803\uDCD5'],
    ['\uD803\uDC96', '\uD803\uDCD6'],
    ['\uD803\uDC97', '\uD803\uDCD7'],
    ['\uD803\uDC98', '\uD803\uDCD8'],
    ['\uD803\uDC99', '\uD803\uDCD9'],
    ['\uD803\uDC9A', '\uD803\uDCDA'],
    ['\uD803\uDC9B', '\uD803\uDCDB'],
    ['\uD803\uDC9C', '\uD803\uDCDC'],
    ['\uD803\uDC9D', '\uD803\uDCDD'],
    ['\uD803\uDC9E', '\uD803\uDCDE'],
    ['\uD803\uDC9F', '\uD803\uDCDF'],
    ['\uD803\uDCA0', '\uD803\uDCE0'],
    ['\uD803\uDCA1', '\uD803\uDCE1'],
    ['\uD803\uDCA2', '\uD803\uDCE2'],
    ['\uD803\uDCA3', '\uD803\uDCE3'],
    ['\uD803\uDCA4', '\uD803\uDCE4'],
    ['\uD803\uDCA5', '\uD803\uDCE5'],
    ['\uD803\uDCA6', '\uD803\uDCE6'],
    ['\uD803\uDCA7', '\uD803\uDCE7'],
    ['\uD803\uDCA8', '\uD803\uDCE8'],
    ['\uD803\uDCA9', '\uD803\uDCE9'],
    ['\uD803\uDCAA', '\uD803\uDCEA'],
    ['\uD803\uDCAB', '\uD803\uDCEB'],
    ['\uD803\uDCAC', '\uD803\uDCEC'],
    ['\uD803\uDCAD', '\uD803\uDCED'],
    ['\uD803\uDCAE', '\uD803\uDCEE'],
    ['\uD803\uDCAF', '\uD803\uDCEF'],
    ['\uD803\uDCB0', '\uD803\uDCF0'],
    ['\uD803\uDCB1', '\uD803\uDCF1'],
    ['\uD803\uDCB2', '\uD803\uDCF2'],
    ['\uD806\uDCA0', '\uD806\uDCC0'],
    ['\uD806\uDCA1', '\uD806\uDCC1'],
    ['\uD806\uDCA2', '\uD806\uDCC2'],
    ['\uD806\uDCA3', '\uD806\uDCC3'],
    ['\uD806\uDCA4', '\uD806\uDCC4'],
    ['\uD806\uDCA5', '\uD806\uDCC5'],
    ['\uD806\uDCA6', '\uD806\uDCC6'],
    ['\uD806\uDCA7', '\uD806\uDCC7'],
    ['\uD806\uDCA8', '\uD806\uDCC8'],
    ['\uD806\uDCA9', '\uD806\uDCC9'],
    ['\uD806\uDCAA', '\uD806\uDCCA'],
    ['\uD806\uDCAB', '\uD806\uDCCB'],
    ['\uD806\uDCAC', '\uD806\uDCCC'],
    ['\uD806\uDCAD', '\uD806\uDCCD'],
    ['\uD806\uDCAE', '\uD806\uDCCE'],
    ['\uD806\uDCAF', '\uD806\uDCCF'],
    ['\uD806\uDCB0', '\uD806\uDCD0'],
    ['\uD806\uDCB1', '\uD806\uDCD1'],
    ['\uD806\uDCB2', '\uD806\uDCD2'],
    ['\uD806\uDCB3', '\uD806\uDCD3'],
    ['\uD806\uDCB4', '\uD806\uDCD4'],
    ['\uD806\uDCB5', '\uD806\uDCD5'],
    ['\uD806\uDCB6', '\uD806\uDCD6'],
    ['\uD806\uDCB7', '\uD806\uDCD7'],
    ['\uD806\uDCB8', '\uD806\uDCD8'],
    ['\uD806\uDCB9', '\uD806\uDCD9'],
    ['\uD806\uDCBA', '\uD806\uDCDA'],
    ['\uD806\uDCBB', '\uD806\uDCDB'],
    ['\uD806\uDCBC', '\uD806\uDCDC'],
    ['\uD806\uDCBD', '\uD806\uDCDD'],
    ['\uD806\uDCBE', '\uD806\uDCDE'],
    ['\uD806\uDCBF', '\uD806\uDCDF'],
    ['\uD81B\uDE40', '\uD81B\uDE60'],
    ['\uD81B\uDE41', '\uD81B\uDE61'],
    ['\uD81B\uDE42', '\uD81B\uDE62'],
    ['\uD81B\uDE43', '\uD81B\uDE63'],
    ['\uD81B\uDE44', '\uD81B\uDE64'],
    ['\uD81B\uDE45', '\uD81B\uDE65'],
    ['\uD81B\uDE46', '\uD81B\uDE66'],
    ['\uD81B\uDE47', '\uD81B\uDE67'],
    ['\uD81B\uDE48', '\uD81B\uDE68'],
    ['\uD81B\uDE49', '\uD81B\uDE69'],
    ['\uD81B\uDE4A', '\uD81B\uDE6A'],
    ['\uD81B\uDE4B', '\uD81B\uDE6B'],
    ['\uD81B\uDE4C', '\uD81B\uDE6C'],
    ['\uD81B\uDE4D', '\uD81B\uDE6D'],
    ['\uD81B\uDE4E', '\uD81B\uDE6E'],
    ['\uD81B\uDE4F', '\uD81B\uDE6F'],
    ['\uD81B\uDE50', '\uD81B\uDE70'],
    ['\uD81B\uDE51', '\uD81B\uDE71'],
    ['\uD81B\uDE52', '\uD81B\uDE72'],
    ['\uD81B\uDE53', '\uD81B\uDE73'],
    ['\uD81B\uDE54', '\uD81B\uDE74'],
    ['\uD81B\uDE55', '\uD81B\uDE75'],
    ['\uD81B\uDE56', '\uD81B\uDE76'],
    ['\uD81B\uDE57', '\uD81B\uDE77'],
    ['\uD81B\uDE58', '\uD81B\uDE78'],
    ['\uD81B\uDE59', '\uD81B\uDE79'],
    ['\uD81B\uDE5A', '\uD81B\uDE7A'],
    ['\uD81B\uDE5B', '\uD81B\uDE7B'],
    ['\uD81B\uDE5C', '\uD81B\uDE7C'],
    ['\uD81B\uDE5D', '\uD81B\uDE7D'],
    ['\uD81B\uDE5E', '\uD81B\uDE7E'],
    ['\uD81B\uDE5F', '\uD81B\uDE7F'],
    ['\uD83A\uDD00', '\uD83A\uDD22'],
    ['\uD83A\uDD01', '\uD83A\uDD23'],
    ['\uD83A\uDD02', '\uD83A\uDD24'],
    ['\uD83A\uDD03', '\uD83A\uDD25'],
    ['\uD83A\uDD04', '\uD83A\uDD26'],
    ['\uD83A\uDD05', '\uD83A\uDD27'],
    ['\uD83A\uDD06', '\uD83A\uDD28'],
    ['\uD83A\uDD07', '\uD83A\uDD29'],
    ['\uD83A\uDD08', '\uD83A\uDD2A'],
    ['\uD83A\uDD09', '\uD83A\uDD2B'],
    ['\uD83A\uDD0A', '\uD83A\uDD2C'],
    ['\uD83A\uDD0B', '\uD83A\uDD2D'],
    ['\uD83A\uDD0C', '\uD83A\uDD2E'],
    ['\uD83A\uDD0D', '\uD83A\uDD2F'],
    ['\uD83A\uDD0E', '\uD83A\uDD30'],
    ['\uD83A\uDD0F', '\uD83A\uDD31'],
    ['\uD83A\uDD10', '\uD83A\uDD32'],
    ['\uD83A\uDD11', '\uD83A\uDD33'],
    ['\uD83A\uDD12', '\uD83A\uDD34'],
    ['\uD83A\uDD13', '\uD83A\uDD35'],
    ['\uD83A\uDD14', '\uD83A\uDD36'],
    ['\uD83A\uDD15', '\uD83A\uDD37'],
    ['\uD83A\uDD16', '\uD83A\uDD38'],
    ['\uD83A\uDD17', '\uD83A\uDD39'],
    ['\uD83A\uDD18', '\uD83A\uDD3A'],
    ['\uD83A\uDD19', '\uD83A\uDD3B'],
    ['\uD83A\uDD1A', '\uD83A\uDD3C'],
    ['\uD83A\uDD1B', '\uD83A\uDD3D'],
    ['\uD83A\uDD1C', '\uD83A\uDD3E'],
    ['\uD83A\uDD1D', '\uD83A\uDD3F'],
    ['\uD83A\uDD1E', '\uD83A\uDD40'],
    ['\uD83A\uDD1F', '\uD83A\uDD41'],
    ['\uD83A\uDD20', '\uD83A\uDD42'],
    ['\uD83A\uDD21', '\uD83A\uDD43'],
    // F
    ['\xDF', 'ss'],
    ['\u0130', 'i\u0307'],
    ['\u0149', '\u02BCn'],
    ['\u01F0', 'j\u030C'],
    ['\u0390', '\u03B9\u0308\u0301'],
    ['\u03B0', '\u03C5\u0308\u0301'],
    ['\u0587', '\u0565\u0582'],
    ['\u1E96', 'h\u0331'],
    ['\u1E97', 't\u0308'],
    ['\u1E98', 'w\u030A'],
    ['\u1E99', 'y\u030A'],
    ['\u1E9A', 'a\u02BE'],
    ['\u1E9E', 'ss'],
    ['\u1F50', '\u03C5\u0313'],
    ['\u1F52', '\u03C5\u0313\u0300'],
    ['\u1F54', '\u03C5\u0313\u0301'],
    ['\u1F56', '\u03C5\u0313\u0342'],
    ['\u1F80', '\u1F00\u03B9'],
    ['\u1F81', '\u1F01\u03B9'],
    ['\u1F82', '\u1F02\u03B9'],
    ['\u1F83', '\u1F03\u03B9'],
    ['\u1F84', '\u1F04\u03B9'],
    ['\u1F85', '\u1F05\u03B9'],
    ['\u1F86', '\u1F06\u03B9'],
    ['\u1F87', '\u1F07\u03B9'],
    ['\u1F88', '\u1F00\u03B9'],
    ['\u1F89', '\u1F01\u03B9'],
    ['\u1F8A', '\u1F02\u03B9'],
    ['\u1F8B', '\u1F03\u03B9'],
    ['\u1F8C', '\u1F04\u03B9'],
    ['\u1F8D', '\u1F05\u03B9'],
    ['\u1F8E', '\u1F06\u03B9'],
    ['\u1F8F', '\u1F07\u03B9'],
    ['\u1F90', '\u1F20\u03B9'],
    ['\u1F91', '\u1F21\u03B9'],
    ['\u1F92', '\u1F22\u03B9'],
    ['\u1F93', '\u1F23\u03B9'],
    ['\u1F94', '\u1F24\u03B9'],
    ['\u1F95', '\u1F25\u03B9'],
    ['\u1F96', '\u1F26\u03B9'],
    ['\u1F97', '\u1F27\u03B9'],
    ['\u1F98', '\u1F20\u03B9'],
    ['\u1F99', '\u1F21\u03B9'],
    ['\u1F9A', '\u1F22\u03B9'],
    ['\u1F9B', '\u1F23\u03B9'],
    ['\u1F9C', '\u1F24\u03B9'],
    ['\u1F9D', '\u1F25\u03B9'],
    ['\u1F9E', '\u1F26\u03B9'],
    ['\u1F9F', '\u1F27\u03B9'],
    ['\u1FA0', '\u1F60\u03B9'],
    ['\u1FA1', '\u1F61\u03B9'],
    ['\u1FA2', '\u1F62\u03B9'],
    ['\u1FA3', '\u1F63\u03B9'],
    ['\u1FA4', '\u1F64\u03B9'],
    ['\u1FA5', '\u1F65\u03B9'],
    ['\u1FA6', '\u1F66\u03B9'],
    ['\u1FA7', '\u1F67\u03B9'],
    ['\u1FA8', '\u1F60\u03B9'],
    ['\u1FA9', '\u1F61\u03B9'],
    ['\u1FAA', '\u1F62\u03B9'],
    ['\u1FAB', '\u1F63\u03B9'],
    ['\u1FAC', '\u1F64\u03B9'],
    ['\u1FAD', '\u1F65\u03B9'],
    ['\u1FAE', '\u1F66\u03B9'],
    ['\u1FAF', '\u1F67\u03B9'],
    ['\u1FB2', '\u1F70\u03B9'],
    ['\u1FB3', '\u03B1\u03B9'],
    ['\u1FB4', '\u03AC\u03B9'],
    ['\u1FB6', '\u03B1\u0342'],
    ['\u1FB7', '\u03B1\u0342\u03B9'],
    ['\u1FBC', '\u03B1\u03B9'],
    ['\u1FC2', '\u1F74\u03B9'],
    ['\u1FC3', '\u03B7\u03B9'],
    ['\u1FC4', '\u03AE\u03B9'],
    ['\u1FC6', '\u03B7\u0342'],
    ['\u1FC7', '\u03B7\u0342\u03B9'],
    ['\u1FCC', '\u03B7\u03B9'],
    ['\u1FD2', '\u03B9\u0308\u0300'],
    ['\u1FD3', '\u03B9\u0308\u0301'],
    ['\u1FD6', '\u03B9\u0342'],
    ['\u1FD7', '\u03B9\u0308\u0342'],
    ['\u1FE2', '\u03C5\u0308\u0300'],
    ['\u1FE3', '\u03C5\u0308\u0301'],
    ['\u1FE4', '\u03C1\u0313'],
    ['\u1FE6', '\u03C5\u0342'],
    ['\u1FE7', '\u03C5\u0308\u0342'],
    ['\u1FF2', '\u1F7C\u03B9'],
    ['\u1FF3', '\u03C9\u03B9'],
    ['\u1FF4', '\u03CE\u03B9'],
    ['\u1FF6', '\u03C9\u0342'],
    ['\u1FF7', '\u03C9\u0342\u03B9'],
    ['\u1FFC', '\u03C9\u03B9'],
    ['\uFB00', 'ff'],
    ['\uFB01', 'fi'],
    ['\uFB02', 'fl'],
    ['\uFB03', 'ffi'],
    ['\uFB04', 'ffl'],
    ['\uFB05', 'st'],
    ['\uFB06', 'st'],
    ['\uFB13', '\u0574\u0576'],
    ['\uFB14', '\u0574\u0565'],
    ['\uFB15', '\u0574\u056B'],
    ['\uFB16', '\u057E\u0576'],
    ['\uFB17', '\u0574\u056D'],
    // T
    ['I', '\u0131'],
    ['\u0130', 'i'],
]);
export function caseFold(s) {
    return s.replaceAll(changesWhenCasefolded, (foldableChar) => {
        const folded = cft.get(foldableChar);
        if (folded == null) {
            console.warn('Code point not found in the case folding map:', foldableChar.codePointAt(0));
            return foldableChar;
        }
        return folded;
    });
}
